/*
 *
 * GoogleVerify actions
 *
 */

import { VERIFY_GOOGLE } from './constants';
import { defineAction } from 'utils/action-helper';

export const verifyGoogle = {
  start: ({ payload, metadata }) => defineAction({ type: VERIFY_GOOGLE.START, payload, metadata }),
  success: () => {
    return defineAction({ type: VERIFY_GOOGLE.SUCCESS });
  },
  error: ({ error }) =>
    defineAction({
      type: VERIFY_GOOGLE.ERROR,
      payload: {
        error,
      },
    }),
};
